import React from 'react';

import styles from './font-picker-modal-button.scss';

export default function ModalButton({ onClick, label }) {
  return (
    <div onClick={onClick} className={styles.button}>
      {label}
    </div>
  );
}

ModalButton.propTypes = {
  onClick: React.PropTypes.func.isRequired,
  label: React.PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/fonts/font-picker/font-picker-modal-button.jsx